import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3deba19a")
const _hoisted_1 = { class: "mt-[12px]" }
const _hoisted_2 = { class: "flex flex-1" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "token" }
const _hoisted_5 = { class: "token-value flex flex-1 flex-col text-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "break my-[12px]" }, null, -1)
const _hoisted_7 = { class: "mt-[24px] grid grid-cols-2 gap-[8px]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "Pool Share", -1)
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "Staked LP Tokens", -1)
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "Unstaked LP Tokens", -1)
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "Daily earning", -1)
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "xPolar to Claim", -1)
const _hoisted_17 = { class: "claim text-right" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAsset = _resolveComponent("BalAsset")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokenAddresses, (address, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "py-[12px] flex"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BalAsset, {
              address: address,
              size: 33,
              class: "mr-[12px]"
            }, null, 8, ["address"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.symbolFor(address)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.tokenWeightFor(address)) + "%", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, _toDisplayString(_ctx.isWalletReady
              ? _ctx.fNum2(_ctx.propTokenAmounts[idx], _ctx.FNumFormats.token)
              : '-'), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.isWalletReady ? _ctx.fiatLabelFor(idx, address) : '-'), 1)
          ])
        ]))
      }), 128))
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.poolSharePerc), 1),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.stakedBalance), 1),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.unstakedTokens), 1),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.dailyEarnings) + " $", 1),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.xpolarToClaim), 1)
    ])
  ], 64))
}